<template>
    <div v-show="isAvailable" class="list-available form-group row align-items-start">
        <label for="inputs_bank_account_id" class="col-sm-3 mb-0 mt-3">
            {{ label }}
        </label>
        <div class="col-sm-9">
            <app-table :id="tableId" class="h-auto" :options="options" />
        </div>
    </div>
</template>

<script>
import { API_VOUCHER_BY_LEAD } from '../../../Config/ApiUrl';

export default {
    name: "ListAvailableVoucher",
    props: {
        tableId: {
            type: String,
            default: 'list-available-vouchers',
        },
        label: {
            type: String,
            default: 'Vouchers',
        },
        url: {
            type: String,
            default: API_VOUCHER_BY_LEAD,
        },
    },
    data() {
        return {
            options: {
                url: this.url,
                showHeader: false,
                columns: [
                    // {
                    //     title: this.$t('table_voucher_code'),
                    //     type: "text",
                    //     key: "voucher_code",
                    // },
                    {
                        title: this.$t('table_voucher_description'),
                        type: "text",
                        titleAlignment: "left",
                        key: "voucher_category",
                    },
                    {
                        title: this.$t('table_voucher_category_deduction'),
                        type: "custom-html",
                        key: "deduction",
					    titleAlignment: "right",
                        modifier: (value) => {
                            // console.log(value);
                            return this.formattedIDR(value) ?? this.formattedIDR(0);
                        },
                    },
                ],
                actions: [],
                filters: [],
                tablePaddingClass: 'p-0 m-0',
                paginationBlockClass: 'p-0 m-0',
                datatableWrapper: false,
                showFilter: false,
                showHeader: false,
                showSearch: false,
                enableCookie: false,
                showCount: false,
                showClearFilter: false,
                enableSaveFilter: false,
                enableHighlights: false,
                responsive: true,
                showAction: true,
                orderBy: "desc",
                afterRequestSuccess: (res) => {
                    // console.log(res.data.data);
                    this.isAvailable = (res?.data?.data?.length ?? 0) > 0;
                },
            },
            isAvailable: false,
            availableOptions: [],
        };
    },
    watch: {
        url(newUrl, oldUrl) {
            if (newUrl != oldUrl) {
                this.options.url = newUrl;
                this.$hub.$emit("reload-" + this.tableId);
            }
        },
    },
    methods: {
        formattedIDR(value) {
            // Format the value as IDR
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
                minimumFractionDigits: 0,
            }).format(value);
        },
    },
};
</script>

<style>
.list-available .datatable .table-responsive {
    padding-top: 1rem !important;
    min-height: auto !important;
    height: auto !important;
    box-shadow: none !important;
}
</style>